import logo from 'assets/img/cbg-logo.svg';
import cn from 'classnames';
import { Container } from 'layout/Grid';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from 'utils/scrollPage';
import { getPathInfo } from 'utils/versionUtils';
import styles from './layout.module.scss';

export interface ErrorPageLayoutProps {
  children: React.ReactNode;
}

const ErrorPageLayout: React.FC<ErrorPageLayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const { polVersion } = getPathInfo();

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return (
    <>
      <div className={styles.root}>
        <Container>
          <div className={cn(styles.header)}>
            <div role="banner" className={styles.centeredLogo}>
              <img width="96px" src={logo} alt="carlsberg group logo" />
            </div>
          </div>

          <main>{children}</main>
        </Container>
      </div>
    </>
  );
};

export default ErrorPageLayout;
